import { render, staticRenderFns } from "./statsTab.vue?vue&type=template&id=713923a0&scoped=true"
import script from "./statsTab.vue?vue&type=script&lang=js"
export * from "./statsTab.vue?vue&type=script&lang=js"
import style0 from "./statsTab.vue?vue&type=style&index=0&id=713923a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713923a0",
  null
  
)

export default component.exports